import { useCurrentAccount } from '@application/api';
import { useModal, useRouter } from '@application/utils';
import { AuthModal } from '@presentation/components';
import type { FC } from 'react';
import { singletonHook } from 'react-singleton-hook';

const init: ReturnType<typeof useAuthModalSingleton> = {
  show: () => undefined,
  showFromClick: () => undefined,
  close: () => undefined,
  modal: {
    onCloseClick: undefined,
    open: false,
    position: [0, 0],
  },
};

export const useAuthModalSingleton = () => {
  const modalHook = useModal({});
  return modalHook;
};

export const useAuthModal = singletonHook(init, useAuthModalSingleton);

export const AuthModalController: FC = () => {
  const { modal, close } = useAuthModal();
  const { translate, navigateToRoute, infoFromCurrentPath } = useRouter();
  const { currentAccount, currentAccountLogout } = useCurrentAccount();

  let subtitle: string | undefined;
  if (infoFromCurrentPath.route === 'stud') {
    subtitle = translate('common.modals.studAuth.subtitleBuyer');
    if (!currentAccount?.dogBreeder?.certified) {
      subtitle = translate('common.modals.studAuth.subtitleUncertifiedBreeder');
    }
  }

  return (
    <AuthModal
      modal={modal}
      // Different messaging done in the wrong place, but could not find any other way
      subtitle={subtitle}
      onLoginClick={() => {
        currentAccountLogout();
        navigateToRoute('login', {
          state: {
            returnInfo: infoFromCurrentPath,
          },
        });
        close();
      }}
      onJoinClick={() => {
        currentAccountLogout();
        navigateToRoute('joinBuyer', {
          state: {
            returnInfo: infoFromCurrentPath,
          },
        });
        close();
      }}
    />
  );
};
